import React from 'react';
import { Input } from 'antd';

const CustomInputField = ({ ...props }) => {
  return <Input {...props} />;
};

export default CustomInputField;
